<div
  data-testid="QtySection"
  class="disp-inl-flex"
  tooltipPosition="bottom"
  positionStyle="absolute"
  tooltipZIndex="20000"
  class="quantityGroup"
>
  <div class="row">
    <div class="col-4">
      <button
        class="button button-small quantityControls"
        [ngClass]="btnStyleClass"
        [disabled]="this.QtyControlsDisabled"
        #decreaseBtn
        (click)="changeQuantity(-1)"
      >
        <i class="fa-solid fa-minus" data-testid="btnQuantityControlDecrease"></i>
      </button>
    </div>
    <div class="col-4">
      <span class="outerBorder unselectable">
        <input
          id="quantityValue"
          aria-label="Quantity Value"
          type="number"
          #edit
          class="quantityValue"
          [ngClass]="inputStyleClass"
          [disabled]="this.QtyControlsDisabled || addDisabled"
          [(ngModel)]="selectedValue"
          [readonly]="isReadOnly"
          (blur)="onInputBlur($event)"
          (keypress)="disallowNonNumbers($event)"
          (paste)="disallowPaste()"
          data-testid="inputQuantityControl"
        />
      </span>
    </div>
    <div class="col-4">
      <div
        placement="bottom"
        tt_datatestid="quantitycontrol-disable-tooltip"
        tt_datapendoid="quantitycontrol-disable-tooltip"
        tt_arialabel="Quantity control disable tooltip"
        [rw-tooltip]="(disabled || addDisabled) ? tooltipText : ''"
      >
        <button
          class="button button-small quantityControls"
          [ngClass]="btnStyleClass"
          #increaseBtn
          (click)="changeQuantity(1)"
          [disabled]="addDisabled"
          data-testid="btnQuantityControlIncrease"
        >
          <i class="fa-solid fa-plus"></i>
        </button>
      </div>
    </div>
  </div>
</div>
